import { render, staticRenderFns } from "./WarningOnAccessFromIosDialog.vue?vue&type=template&id=183d76fc&"
import script from "./WarningOnAccessFromIosDialog.vue?vue&type=script&lang=ts&"
export * from "./WarningOnAccessFromIosDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports